import { StorageService } from "../services";
import AcceptedLanguageEnum from "../enums/AcceptedLanguage";

function getBrowserLangCode(): string {
    try {
        const browserLang = (typeof navigator !== 'undefined' && navigator.language) || 
                           (typeof navigator !== 'undefined' && navigator.languages?.[0]) || 
                           'en';
        return typeof browserLang === 'string' ? browserLang.split('-')[0] : 'en';
    } catch (error) {
        // Fallback to English if any error occurs
        return 'en';
    }
}

/**
 * Detects the user's preferred language
 * Priority: 1. Saved preference, 2. Browser language, 3. English fallback
 */
export default function detectLanguage(): string {
    // First priority: saved language preference
    if (StorageService.langCode && AcceptedLanguageEnum.isSupported(StorageService.langCode)) {
        return StorageService.langCode;
    }

    // Second priority: browser default language
    const langCode = getBrowserLangCode();
    
    // If Russian, use Ukrainian instead (business logic)
    if (langCode === 'ru') {
        return 'uk';
    }
    
    // Return supported language or default to English
    return AcceptedLanguageEnum.isSupported(langCode) ? langCode : 'en';
}
